import axios from 'axios'
import qs from 'qs'
import pubFunction from '../public/index.js'
import {
	Notification
} from 'element-ui'
import store from '../store/index.js'
// 公共请求路径
const requestUrl = pubFunction.requestUrl //固定

// 需要token验证的接口
const tokenApi = [
	'findAppraiserList',
	'findAppraiserById',
	'addOrUpdateAppraiser',
	'deleteAppraiser',
	'exportAppraiser',
	'findCaseInformationList',
	'findCaseInformationById',
	'checkIdentified',
	'addOrUpdateCaseInformation',
	'submitOpinion',
	'deleteCaseInformation',
	'exportCaseInfo',
	'exportCaseInfoGov',
	'exportCaseInfoInput',
	'getEntrustWord',
	'getAlTotalCase',
	'findOrganizationList',
	'findOrganizationById',
	'addOrUpdateOrganization',
	'deleteOrganization',
	'exportOrgan',
	'authenReal',
	'statistics',
	'entrustedAgencystatistics',
	'statisticsByOrganType',
	'statisticsByCity',
	'userLoginInfo',
	'findSystemDictonaryList',
	'changePassword',
	'changeCaseInfo',
	'changeCaseInfoAuditDetail',
	'cacheData',
	'findCacheData',
	'findAppraiserByOrganNo',
	'supplementCaseInformation'
]
// 非必须token验证的接口
const loginApi = [

]
const uploadApi = [
	'uploadImg'
]
// 本地token验证
const doRequest = (api, data, type, callback) => {
	let token = pubFunction.getStorage('i_token')
	// 必需token验证
	if (tokenApi.indexOf(api) >= 0) {
		if (!token) {
			disposeNologin()
			return false
		} else {
			axios.defaults.headers.common["X-Token"] = token
		}
	}
	// 非必须token验证
	if (loginApi.indexOf(api) >= 0) {
		axios.defaults.headers.common["X-Token"] = token
	}
	let url = requestUrl + api
	if (uploadApi.indexOf(api) >= 0) {
		axios.defaults.headers.common["X-Token"] = token
		doUpload(url, data, callback)
		return
	}
	sendPost(url, data, type, callback)
}
// 统一处理登录失效方法
const disposeNologin = () => {
	resetHeader()
	Notification.error({
		title: '发生错误',
		message: '当前登录状态已失效，请您重新登录。',
		duration: 2000,
		onClose: () => {
			store.commit('logout')
		}
	})
}
// 处理错误
const disposeError = (msg) => {
	Notification.error({
		title: '发生错误',
		message: msg,
		duration: 2000
	})
}
const resetHeader = () => {
	delete axios.defaults.headers.common['X-Token']
}
// 统一请求方法
const sendPost = (url, data, type, callback) => {
	if (type == 'GET') {
		axios.get(url, {
			params: data
		}, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then((res) => {
			if (res.data.code == 203) {
				disposeNologin()
				return
			} else if (res.data.code != 200) {
				disposeError(res.data.msg)
			}
			callback(res.data)
		}).catch((err) => {
			console.log(err)
			disposeError('发生了未知错误，请修改数据后尝试重新提交')
			callback()
		})
	} else {
		data = qs.stringify(data)
		axios.post(url, data, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded"
			}
		}).then((res) => {
			if (res.data.code == 203) {
				disposeNologin()
				return
			} else if (res.data.code != 200) {
				disposeError(res.data.msg)
			}
			callback(res.data)
		}).catch((err) => {
			disposeError('发生了未知错误，请修改数据后尝试重新提交')
			callback()
		})
	}
}
const doUpload = (url, data, callback) => {
	axios.post(url, data, {
		headers: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	}).then((res) => {
		if (res.data.code == 203) {
			disposeNologin()
			return
		} else if (res.data.code != 200) {
			disposeError(res.data.msg)
		}
		callback(res.data)
	}).catch((err) => {
		disposeError('发生了未知错误，请修改数据后尝试重新提交')
		callback()
	})
}


// 调取所有的机构列表
const organList = (data, callback) => doRequest('OrganizationList', data, 'GET', callback)
// 登录方法
// const login = (data, callback) => doRequest('fgLogin', data, 'POST', callback)
// 调取实名二维码
const realCode = (data, callback) => doRequest('getErCode', data, 'POST', callback)
// 提交人脸识别信息
const submitPhoto = (data, callback) => doRequest('faceSearch', data, 'POST', callback)
// 轮询结果
const realResult = (data, callback) => doRequest('getLoginStatus', data, '', callback)
// 查询个人信息
const getUserInfo = (data, callback) => doRequest('', data, '', callback)
// 查询权限路由
const getPermissionRouter = (data, callback) => doRequest('userLoginInfo', data, 'GET', callback)
// 上传图片
const uploadImage = (data, callback) => doRequest('uploadImg', data, 'POST', callback)
// 提交身份资料
const submitReal = (data, callback) => doRequest('authenReal', data, 'POST', callback)
// 案件列表
const findCaseInformationList = (data, callback) => doRequest('findCaseInformationList', data, 'POST', callback)
// 根据机构查列表
const getCaseStatusByOrganNo = (data, callback) => doRequest('getCaseStatusByOrganNo', data, 'GET', callback)
// 案件详情
const findCaseInformationById = (data, callback) => doRequest('findCaseInformationById', data, 'GET', callback)
// 导出
const exportCaseInfoInput = (data, callback) => doRequest('exportCaseInfoInput', data, 'GET', callback)
// 添加新的鉴定委托
const newEntruseData = (data, callback) => doRequest('addOrUpdateCaseInformation', data, 'POST', callback)
// 变更委托书
const changeCaseInfo = (data, callback) => doRequest('changeCaseInfo', data, 'POST', callback)
// 变更委托书详情
const changeCaseDetail = (data, callback) => doRequest('changeCaseInfoAuditDetail', data, 'GET', callback)
// 查询被鉴定人是否做过鉴定
const queryTargetRecord = (data, callback) => doRequest('checkIdentified', data, 'GET', callback)
// 委托鉴定事项
const getAllMatter = (data, callback) => doRequest('getAllMatter', data, 'GET', callback)
// 各种下拉列表
const findSystemDictonaryList = (data, callback) => doRequest('findSystemDictonaryList', data, 'GET', callback)
// 机构详情
const findOrganizationById = (data, callback) => doRequest('findOrganizationById', data, 'GET', callback)
// 保存鉴定意见
const saveExpertise = (data, callback) => doRequest('submitOpinion', data, 'POST', callback)
// 补充鉴定
const saveReplenish = (data, callback) => doRequest('supplementCaseInformation', data, 'POST', callback)
// 查询是否存在同编号
const checkRepeat = (data, callback) => doRequest('checkCaseNo', data, 'GET', callback)
// 获取委托书
const getEntrustWord = (data, callback) => doRequest('getEntrustWord', data, 'GET', callback)
// 修改密码
const changePassword = (data, callback) => doRequest('changePassword', data, 'GET', callback)
// 获取省市县列表
const getAreaList = (data, callback) => doRequest('getArea', data, 'GET', callback)
// 获取暂存数据
const getTemporarySaveData = (data, callback) => doRequest('findCacheData', data, 'GET', callback)
// 暂存
const temporarySave = (data, callback) => doRequest('cacheData', data, 'POST', callback)
// 获取鉴定人列表
const getProfessorList = (data, callback) => doRequest('findAppraiserByOrganNo', data, 'GET', callback)


export default {
	organList,
	// login,
	realCode,
	submitPhoto,
	realResult,
	getUserInfo,
	getPermissionRouter,
	uploadImage,
	submitReal,
	findCaseInformationList,
	getCaseStatusByOrganNo,
	findCaseInformationById,
	exportCaseInfoInput,
	newEntruseData,
	changeCaseInfo,
	changeCaseDetail,
	queryTargetRecord,
	getAllMatter,
	findSystemDictonaryList,
	findOrganizationById,
	saveExpertise,
	saveReplenish,
	checkRepeat,
	resetHeader,
	getEntrustWord,
	changePassword,
	getAreaList,
	getTemporarySaveData,
	temporarySave,
	getProfessorList
}